/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

// defines the enumeration for languages supported in iOn applications ...
export enum Language {
  default = 'default',
  en = 'en',
  it = 'it',
  'en-GB' = 'en-GB',
  'es-ES' = 'es-ES',
  'es-MX' = 'es-MX',
  'pt-BR' = 'pt-BR'
};

// defines the type definitions for user preferences ...
export interface Preferences {
  defaultPageId?: string;
  persistGridLayouts?: boolean;
  unitOfMeasure?: string;
  timeZone?: string;
  userTimeZone?: string;
  accountTimeZone?: string;
  defaultGroupId?: number;
  defaultLanguage?: Language;
  defaultDateFormat?: string;
  defaultTimeFormat?: string;
  showNotifications?: boolean;
  showUrgentNotifications?: boolean;
  showGeneralNotifications?: boolean;
  showTimeRelatedNotifications?: boolean;
  showConnectivityNotifications?: boolean;
  showScheduledEventsNotifications?: boolean;
  selectedNotificationsPerPage?: string;
};

// defines the enumeration for user preference ...
export enum Preference {
  // [CORE PACKAGE TODO]: Please note, while some of these preferences are shared, many are 
  // specific to the ion-suite package, as such, they will be refactored to packages/ion-suite in
  // the future.
  defaultPageId = 'defaultPageId',
  defaultGroupId = 'defaultGroupId',
  persistGridLayouts = 'persistGridLayouts',
  timeZone = 'timeZone',
  userTimeZone = 'userTimeZone',
  unitOfMeasure = 'unitOfMeasure',
  defaultLanguage = 'defaultLanguage',
  defaultTimeFormat = 'defaultTimeFormat',
  defaultDateFormat = 'defaultDateFormat',
  showNotifications = 'showNotifications',
  showUrgentNotifications = 'showUrgentNotifications',
  showGeneralNotifications = 'showGeneralNotifications',
  showTimeRelatedNotifications = 'showTimeRelatedNotifications',
  showConnectivityNotifications = 'showConnectivityNotifications',
  showScheduledEventsNotifications = 'showScheduledEventsNotifications',
  selectedNotificationsPerPage = 'selectedNotificationsPerPage',
  trackingMapLayers = 'tracking.map.layers',
  trackingAssetViewMode = 'trackingAssetViewMode',
  trackingAssetHistory = 'trackingAssetHistory',
  trackingBottomGridHeight = 'trackingBottomGridHeight',
  savedMapViews = 'savedMapViews',
  gridRowsPerPage = 'gridRowsPerPage',
  collapsedNavigation = 'collapsedNavigation'
};
